export const RoutesConstants = {
  HOMEPAGE: '/candidates/board',
  CANDIDATES_BOARD: '/candidates/board',
  CANDIDATES_LIST: '/candidates/list',
};
